<template>
  <kst-section :title="Info.Section.TransactionSetting.Title">
    <kst-input field="DiscPercent" :data="userData" :catalog="Catalog"/>
  </kst-section>
</template>

<script>
import Catalog from "../CliCatalog.js";
import Info from "../CliInfo.js";

export default {
  props: {
    userData: Object
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info,
  })
}
</script>